import { mapActions, mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';

const storeModuleName = 'media_contents';

export default {
    computed: {
        ...mapGetters(storeModuleName, [
            'progressIdx',
            'reloadIdx',
            'mediaContentsApi',
        ]),
    },
    watch: {
        reloadIdx: debounce(function (value) {
            // 리스트 전체 갱신 용도
            if (value !== 1) {
                this.loadMediaContents(this.mediaContentsApi);
            }
        }, 20000),
        progressIdx: debounce(function (value) {
            // 트랜스코딩 진행 퍼센트 갱신 용도
            if (value !== 1) {
                this.getTranscodingProgress();
            }
        }, 5000),
    },
    methods: {
        ...mapMutations({
            clearReloadAndProgressIdx: `${storeModuleName}/clearReloadAndProgressIdx`,
        }),
        ...mapActions({
            loadMediaContents: `${storeModuleName}/loadMediaContents`,
            getTranscodingProgress: `${storeModuleName}/getTranscodingProgress`,
        }),
    },
    beforeDestroy() {
        this.clearReloadAndProgressIdx(); // store mutation
    },
};
